<template>
  <div
    v-if="mismatchWarning"
    class="alert alert-warning d-flex align-items-start gap-2 py-2 px-3 mt-2 mb-0 small"
  >
    <FontAwesomeIcon icon="triangle-exclamation" class="mt-1 flex-shrink-0" />
    <span>{{ mismatchWarning }}</span>
  </div>
  <div
    v-else-if="props.showUnknownHint && unknownCounterparty"
    class="form-text text-warning-emphasis mt-2"
  >
    {{ t("common.eecs_name_mismatch.unknown_counterparty") }}
  </div>
</template>

<script setup lang="ts">
import { useEecsNameMismatchCheck } from "@/composables/useEecsNameMismatchCheck";
import { watchEffect } from "vue";
import { useI18n } from "vue-i18n";

const props = withDefaults(
  defineProps<{
    companyName: string;
    accountNumber: string;
    showUnknownHint?: boolean;
  }>(),
  { showUnknownHint: false }
);

const hasMismatch = defineModel<boolean>("hasMismatch", { default: false });

const { t } = useI18n();

const { mismatchWarning, unknownCounterparty } = useEecsNameMismatchCheck(
  () => props.companyName,
  () => props.accountNumber
);

watchEffect(() => {
  hasMismatch.value = !!mismatchWarning.value;
});
</script>

<style scoped lang="scss"></style>
